import styled from 'styled-components'
import colors from '@settings/styleSettings'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Modal from '@components/modal'

export const ModalContainer = styled(Modal)`
  
`
export const Container = styled.div`
  font-family: 'Circular-Std';
  background: ${colors.grayBackGround};
  height: 100%;
  width: 100%;
  & > div {
    font-family: Circular-Std;  
  }
`

export const TitleContainer = styled.div`
  margin: 0px 40px;
  margin-top: 40px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  flex-direction: row;
  align-items: center;
`

export const TableContainer = styled.div`
  margin: 24px 40px;
  background: ${colors.background};
`

export const TitleArea = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`

export const Title = styled.div`
  font-family: 'Circular-Std';
  font-size: 32px;
  font-weight: 600;
  margin: 0;

  @media (max-width: 985px) {
    font-size: 26px;
  }

`

export const Subtitle = styled.div`
  font-family: 'Circular-Std';
  font-size: 16px;
  font-weight: 450;
  color: ${colors.strongGray};
  margin: 0;

   @media (max-width: 985px) {
    font-size: 14px;
  }
`

export const SwitchContainer = styled.div`
  
`

export const ButtonContainer = styled.div`
  margin: 0 40px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 895px) {
    justify-content: flex-start;
  }
`

export const Button = styled(PrimaryButton)`
  display: flex;
  gap: 8px;
  width: 173px;
  height: 48px;
  font-size: 16px;
`

export const DataHead = styled.div`
  margin-left: 15px;
`
